var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 2.6665C8.63317 2.6665 2.6665 8.63317 2.6665 15.9998C2.6665 23.3665 8.63317 29.3332 15.9998 29.3332C23.3665 29.3332 29.3332 23.3665 29.3332 15.9998C29.3332 8.63317 23.3665 2.6665 15.9998 2.6665ZM15.9998 6.6665C18.2065 6.6665 19.9998 8.45984 19.9998 10.6665C19.9998 12.8798 18.2065 14.6665 15.9998 14.6665C13.7932 14.6665 11.9998 12.8798 11.9998 10.6665C11.9998 8.45984 13.7932 6.6665 15.9998 6.6665ZM15.9998 25.5998C12.6598 25.5998 9.7265 23.8932 7.99984 21.3065C8.03317 18.6598 13.3398 17.1998 15.9998 17.1998C18.6598 17.1998 23.9598 18.6598 23.9998 21.3065C22.2732 23.8932 19.3398 25.5998 15.9998 25.5998Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.9a067c9d01ca06a7f9c1ca07fcfc0ffb.svg";
export { ForwardRef as ReactComponent };